/* ============================================================
   Major Fade Duo — Hero buy section
   Size pills swap the variant id + displayed price WITHOUT
   navigating. Add-to-cart is handled by the theme's existing
   <product-form> element (AJAX + cart drawer).
   ============================================================ */
(function () {
  function initHero(root) {
    if (!root || root.dataset.iaLndgInit === "true") return;
    root.dataset.iaLndgInit = "true";

    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector("[data-ia-lndg-price]");
    var valueEl = root.querySelector("[data-ia-lndg-value]");
    var sizes = root.querySelectorAll(".ia-lndg-hero__size");

    function select(btn) {
      sizes.forEach(function (s) {
        s.classList.remove("is-selected");
        s.setAttribute("aria-checked", "false");
      });
      btn.classList.add("is-selected");
      btn.setAttribute("aria-checked", "true");

      if (idInput && btn.dataset.variantId) idInput.value = btn.dataset.variantId;
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
      if (valueEl) {
        var val = btn.dataset.value || "";
        valueEl.textContent = val;
        valueEl.hidden = !val;
      }
    }

    sizes.forEach(function (btn) {
      btn.addEventListener("click", function () {
        select(btn);
      });
    });

    // Optional play button: tap the muted-autoplay hero video to watch with
    // sound, from the start (same logic as the videos section).
    root.querySelectorAll(".ia-lndg-hero__play").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest(".ia-lndg-hero__media-item");
        var video = item && item.querySelector(".ia-lndg-hero__video");
        if (!video) return;
        video.muted = false;
        video.controls = true;
        video.loop = false;
        try { video.currentTime = 0; } catch (e) {}
        video.play().catch(function () {});
        item.classList.add("is-playing");
      });
    });
  }

  function initAll() {
    document.querySelectorAll(".ia-lndg-hero").forEach(initHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector(".ia-lndg-hero");
    if (root) initHero(root);
  });
})();
